export var Industry;
(function (Industry) {
    Industry["SoftwareAndTechnology"] = "Software & Technology";
    Industry["MediaAdSales"] = "Media Ad Sales";
    Industry["Healthcare"] = "Healthcare";
    Industry["Manufacturing"] = "Manufacturing";
    Industry["Distribution"] = "Distribution";
    // Temporarily removed
    //LifeSciencesAndAnalyticalInstruments = 'Life Sciences & Analytical Instruments',
    Industry["BusinessServices"] = "Business Services";
})(Industry || (Industry = {}));
export var SubIndustry;
(function (SubIndustry) {
    SubIndustry["PureXaaSOverall"] = "Pure XaaS: overall";
    SubIndustry["HybridOverall"] = "Hybrid: overall";
    SubIndustry["PureXaaSInfrastructurePlatform"] = "Pure XaaS: infrastructure / platform";
    SubIndustry["PureXaaSApplicationsServices"] = "Pure XaaS: applications / services";
    SubIndustry["HybridInfrastructurePlatform"] = "Hybrid: infrastructure / platform";
    SubIndustry["HybridApplicationsServices"] = "Hybrid: applications / services";
    SubIndustry["IntegratedPrint"] = "Integrated Print";
    SubIndustry["IntegratedBroadcast"] = "Integrated Broadcast";
    SubIndustry["PurePlayDigitalGT200M"] = "Pure Play Digital (>$200M)";
    SubIndustry["PurePlayDigitalLT200M"] = "Pure Play Digital (<$200M)";
    SubIndustry["MedicalDeviceOverall"] = "Medical Device Overall";
    SubIndustry["HealthcareHighGrowth"] = "Healthcare High Growth";
    SubIndustry["SurgicalDevices"] = "Surgical Devices";
    SubIndustry["CapitalEquipment"] = "Capital Equipment";
    SubIndustry["CardiologyAndNeurology"] = "Cardiology & Neurology";
    SubIndustry["MedicalSupport"] = "Medical Support";
    SubIndustry["PostAcute"] = "Post-Acute";
    SubIndustry["Orthopedics"] = "Orthopedics";
    SubIndustry["Diagnostics"] = "Diagnostics";
    SubIndustry["HealthcareTechnologyAndSoftware"] = "Healthcare Technology & Software";
    SubIndustry["ManufacturingOverall"] = "Manufacturing Overall";
    SubIndustry["IndustrialAndCapitalEquipment"] = "Industrial & Capital Equipment";
    SubIndustry["BuildingMaterialsAndSystems"] = "Building Materials & Systems";
    SubIndustry["MaterialsAndChemicals"] = "Materials & Chemicals";
    SubIndustry["DistributionOverall"] = "Distribution Overall";
    SubIndustry["ElectricalDistribution"] = "Electrical Distribution";
    // Temporarily removed
    // LifeSciencesAndAnalyticalInstrumentsOverall = 'Life Sciences & Analytical Instruments Overall',
    // Instruments = 'Instruments',
    // Consumables = 'Consumables',
    // Research = 'Research',
    // Applied = 'Applied',
    SubIndustry["BusinessServicesOverall"] = "Business Services Overall";
})(SubIndustry || (SubIndustry = {}));
export const IndustryRelationships = {
    [Industry.SoftwareAndTechnology]: [
        SubIndustry.PureXaaSOverall,
        SubIndustry.HybridOverall,
        SubIndustry.PureXaaSInfrastructurePlatform,
        SubIndustry.PureXaaSApplicationsServices,
        SubIndustry.HybridInfrastructurePlatform,
        SubIndustry.HybridApplicationsServices
    ],
    [Industry.MediaAdSales]: [
        SubIndustry.IntegratedPrint,
        SubIndustry.IntegratedBroadcast,
        SubIndustry.PurePlayDigitalGT200M,
        SubIndustry.PurePlayDigitalLT200M
    ],
    [Industry.Healthcare]: [
        SubIndustry.MedicalDeviceOverall,
        SubIndustry.HealthcareHighGrowth,
        SubIndustry.SurgicalDevices,
        SubIndustry.CapitalEquipment,
        SubIndustry.CardiologyAndNeurology,
        SubIndustry.MedicalSupport,
        SubIndustry.PostAcute,
        SubIndustry.Orthopedics,
        SubIndustry.Diagnostics,
        SubIndustry.HealthcareTechnologyAndSoftware
    ],
    [Industry.Manufacturing]: [
        SubIndustry.ManufacturingOverall,
        SubIndustry.IndustrialAndCapitalEquipment,
        SubIndustry.BuildingMaterialsAndSystems,
        SubIndustry.MaterialsAndChemicals
    ],
    [Industry.Distribution]: [SubIndustry.DistributionOverall, SubIndustry.ElectricalDistribution],
    // Temporarily removed
    // [Industry.LifeSciencesAndAnalyticalInstruments]: [
    // 	SubIndustry.LifeSciencesAndAnalyticalInstrumentsOverall,
    // 	SubIndustry.Instruments,
    // 	SubIndustry.Consumables,
    // 	SubIndustry.Research,
    // 	SubIndustry.Applied
    // ],
    [Industry.BusinessServices]: [SubIndustry.BusinessServicesOverall]
};
export class BenchmarkingConstants {
}
// Attributes to keep track when a benchmark was created/updated was added in 2.20.0.
// Any records that don't have the attribute should use this value.
BenchmarkingConstants.MIN_ENTERED_DATE = new Date(Date.UTC(2021, 7, 12, 0, 0, 0, 0));
//# sourceMappingURL=benchmarkingConstants.js.map